import { HttpInterceptorFn, HttpErrorResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { OKTA_AUTH } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";
import { catchError, throwError } from "rxjs";
import { AppConfigService } from "../services/app-config.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const oktaAuth = inject(OKTA_AUTH) as OktaAuth;
  const appConfig = inject(AppConfigService);

  const apiBaseUrl = appConfig.apiBaseUrl;

  // Only add Okta token to our API requests
  if (!apiBaseUrl || !req.url.startsWith(apiBaseUrl)) {
    return next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          oktaAuth.signOut();
        }
        return throwError(() => error);
      }),
    );
  }

  const accessToken = oktaAuth.getAccessToken();

  if (!accessToken) {
    return next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          oktaAuth.signOut();
        }
        return throwError(() => error);
      }),
    );
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        oktaAuth.signOut();
      }
      return throwError(() => error);
    }),
  );
};
